import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '../../../services/axiosBaseQuery';

export const emptySplitApi = createApi({
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    'Stock',
    'Iccid',
    'NumberDiscovery',
    'History',
    'TransferOwnership',
    'AdvancedFeatures',
    'DealerStaff',
    'DealerBind',
    'Supplementary',
    'Whitelist'
  ],
  reducerPath: 'stockApi',
  endpoints: () => ({}),
});
